import { Api } from 'models/services/api';
import { ReadRelationshipsBySupplierIdQuery } from 'models/services/graphql';

import { RelationshipCollectionData } from '../collection';

type DataToFetch = {
  supplierId: string;
  limit?: number;
  nextToken?: string;
};

const RequestQuery = `
  query ReadRelationshipsBySupplierId($supplierId: ID!, $limit: Int, $nextToken: String) {
    ${ReadRelationshipsBySupplierIdQuery}
  }
`;

type ResponseData = {
  data: {
    readRelationshipsBySupplierId: RelationshipCollectionData;
  }
}

class ReadCollectionBySupplierIdGql {

  readonly result?: RelationshipCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readRelationshipsBySupplierId;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionBySupplierIdGql };
